import { baseApi, Http, rtkq, RtkqRequest } from '@app/base';
import { NotificationSetting } from './notificationSettingsTypes';

export const notificationsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    updateNotifications: build.mutation<
      string,
      RtkqRequest<{ userId: string; setting: NotificationSetting[] }>
    >({
      queryFn: rtkq.axios((args) => Http.post(`/api/notifications`, args)),
      invalidatesTags: (_, __, { userId }) => [{ type: 'main:user', userId }],
    }),
  }),
});

export const { useUpdateNotificationsMutation } = notificationsApi;
